<template>
    <div :class="e.size">
        <div class="form-floating" :class="[ type == '' ? 'mb-1' : 'mb-3',  e.opaque ? 'opaque' : '']">
        <template v-if="type == 'select'">
            <select class="form-select" v-bind="$attrs" :id="e.controlId" @change="setValue($event)" :disabled="e.disabled">
                <template v-for="(r,index) in e.list" :key="r">
                    <slot :selected="getValue()" :r="r" :index="index">
                        <option :value="r[bindData]" :selected="C.Str(r[bindData]) == getValue()">{{r[bindText]}}</option>
                    </slot>
                </template>
            </select>
        </template>
        <template v-else-if="type == 'select2'">
            <select class="form-select" v-bind="$attrs" :id="e.controlId" @change="setValue($event)" :disabled="e.disabled">
                <slot :selected="getValue()">
                    <option :value="r[bindData]" v-for="r in e.list" :key="r" :selected="C.Str(r[bindData]) == getValue()">{{r[bindText]}}</option>
                </slot>
            </select>
        </template>
        <template v-else-if="type == 'email'">
            <input type="email" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'password'">
            <input :type="e.showPassword ? 'text': 'password'" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
            <span v-show="!e.disabled" class="input-btn btn" @click="e.showPassword = !e.showPassword"><i class="fa" :class="e.showPassword ? 'fa-eye-slash' : 'fa-eye'" /></span>
        </template>
        <template v-else-if="type == 'tc'">
            <input type="text" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" maxlength="11" />
        </template>
        <template v-else-if="type == 'tel'">
            <input type="tel" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'date'">
            <template v-if="e.disabled">
                <div class="form-control label" v-bind="$attrs" :id="e.controlId" :value="D.DateToString(getValue())">{{ D.DateToString(getValue()) }}</div>
            </template>
            <template v-else>
                <!--<input type="date" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />-->
                <Datepicker class="form-control" v-bind="$attrs" :uid="e.controlId" :modelValue="getValue()" @update:modelValue="setValue($event)" :disabled="e.disabled" :enable-time-picker="false" locale="tr" position="left" select-text="Seç" cancel-text="İptal" :clearable="false" auto-apply format="dd.MM.yyyy"/>
            </template>
        </template>
        <template v-else-if="type == 'time'">
            <template v-if="e.disabled">
                <div class="form-control label" v-bind="$attrs" :id="e.controlId" :value="D.TimeToString(getValue(), true)">{{ D.TimeToString(getValue()) }}</div>
            </template>
            <template v-else>
                <!--<input type="time" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />-->
                <Datepicker class="form-control" v-bind="$attrs" :uid="e.controlId" :modelValue="getValue()" time-picker @update:modelValue="setValue($event)" :disabled="e.disabled" locale="tr" enable-seconds position="left" select-text="Seç" cancel-text="İptal" :clearable="false" auto-apply format="HH:mm:ss" />
            </template>
        </template>
        <template v-else-if="type == 'datetime'">
            <template v-if="e.disabled">
                <div class="form-control label" v-bind="$attrs" :id="e.controlId" :value="D.DateTimeToString(getValue())">{{ D.DateTimeToString(getValue()) }}</div>
            </template>
            <template v-else>
                <Datepicker class="form-control" v-bind="$attrs" :uid="e.controlId" :modelValue="getValue()" @update:modelValue="setValue($event)" :disabled="e.disabled" locale="tr" position="left" select-text="Seç" cancel-text="İptal" :clearable="false" format="dd.MM.yyyy HH:mm"/>
                <!--<input type="datetime-local" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" />-->
            </template>
        </template>
        <template v-else-if="type == 'decimal'">
            <input type="text" class="form-control text-end" min="0.0000" max="999999.0000" step="0.0001" v-bind="$attrs" :id="e.controlId" :value="getValue()" @blur="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'money'">
            <input type="text" class="form-control text-end" min="0.00" max="999999.00" step="0.01" v-bind="$attrs" :id="e.controlId" :value="getValue()" @blur="setValue($event)" :disabled="e.disabled" />
            <span class="input-btn left"><i class="fa fa-try"></i></span>
        </template>
        <template v-else-if="type == 'number'">
            <input type="number" class="form-control text-end" min="0" max="999999" step="1" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'color'">
            <input type="color" class="form-control" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'range'">
            <input type="range" class="form-control form-range" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled" />
        </template>
        <template v-else-if="type == 'checkbox'">
            <div class="form-control" v-bind="$attrs">
                <div class="form-check" v-if="C.IsEmptyArray(e.list)">
                    <input class="form-check-input" type="checkbox" :name="e.controlId" :id="e.controlId + '_0'" value="true" @change="setValue($event)" :checked="C.Bool(getValue())" :disabled="e.disabled"/>
                </div>
                <div class="form-check" v-else :class="{ 'form-check-inline' : C.Bool(inline) }" v-for="(r, index) in e.list" :key="r">
                    <input class="form-check-input" type="checkbox" :name="e.controlId" :id="e.controlId + '_' + index" :value="r[bindData]" @change="setValue($event)" :checked="Text.In(r[bindData], getValue())" :disabled="e.disabled"/>
                    <label class="form-check-label" :for="e.controlId + '_' + index">{{r[bindText]}}</label>
                </div>
            </div>
        </template>
        <template v-else-if="type == 'radio'">
            <div class="form-control" v-bind="$attrs">
                <div class="form-check" :class="{ 'form-check-inline' : C.Bool(inline) }" v-for="(r, index) in e.list" :key="r">
                    <input class="form-check-input" type="radio" :name="e.controlId" :id="e.controlId + '_' + index" :value="r[bindData]" @change="setValue($event)" :checked="C.Str(r[bindData]) == C.Str(getValue())" :disabled="e.disabled"/>
                    <label class="form-check-label" :for="e.controlId + '_' + index">{{r[bindText]}}</label>
                </div>
            </div>
        </template>
        <template v-else-if="type == 'switch'">
            <div class="form-control" v-bind="$attrs">
                <div class="form-check form-switch" v-if="C.IsEmptyArray(e.list)">
                    <input class="form-check-input" type="checkbox" :name="e.controlId" :id="e.controlId + '_0'" value="true" @change="setValue($event)" :checked="C.Bool(getValue())" :disabled="e.disabled"/>
                </div>
                <div class="form-check form-switch" v-else v-for="(r, index) in e.list" :key="r">
                    <input class="form-check-input" type="checkbox" :name="e.controlId" :id="e.controlId + '_' + index" :value="r[bindData]" @change="setValue($event)" :checked="Text.In(r[bindData], getValue())" :disabled="e.disabled"/>
                    <label class="form-check-label" :for="e.controlId + '_' + index">{{r[bindText]}}</label>
                </div>
            </div>
        </template>
        <template v-else-if="type == 'file'">
            <input type="file" class="form-control" v-bind="$attrs" :id="e.controlId" :accept="C.Str(accept, 'image/png,image/jpeg,image/webp,.pdf,.doc,.docx,.xls,.xlsx')" placeholder="Dosya seçiniz..." @change="setValue($event)" :disabled="e.disabled" />
            <div class="mt-1 mb-3" v-if="C.Str(e.value) != '' && !Web.Base64Valid(e.value)">
                <a class="btn btn-sm btn-primary me-1" target="_blank" :href="Web.Media(e.value)">
                    <i class="fa fa-eye" style="color:#fff"></i>
                    <span>Görüntüle</span>
                </a>
            </div>
            <!--<div class="uploads-wrapper form-control">
                <div class="uploads-header">
                    <div class="title">
                        <span><i class="add-file"></i>Dosya Ekle</span>

                    </div>
                    <div class="detail">Bir seferde en fazla 10 dosya ekleyin, Toplam dosya boyutu 25 MB'ı geçemez.</div>
                </div>
                <div class="uploads-body">
                    <div class="file-upload-wrapper">
                        <input type="file" class="file-upload-field" v-bind="$attrs" :id="e.controlId" :accept="C.Str(accept, 'image/png,image/jpeg,image/webp,.pdf,.doc,.docx,.xls,.xlsx')" placeholder="Dosya seçiniz..." @change="setValue($event)" :disabled="e.disabled" />
                    </div>
                </div>
                <div class="uploads-footer">-->
                    <!--<button class="btn btn-primary">Dosya Ekle</button>
                    <button class="btn btn-primary">İptal</button>-->
                <!--</div>
            </div>-->
        </template>
        <template v-else-if="type == 'image'">
            <div :disabled="e.disabled" class="form-control-upload mb-3" @click="imageClick" @dragover="imageDragOver" @dragleave="imageDragLeave" @drop="imageDrop">
                <div class="item" v-if="C.Str(getValue(), 'null') != 'null'">
                    <img :src="Web.Media(getValue(), defaultImage, true)" :style="{'min-height': minHeight, 'max-height': maxHeight}" />
                    <a v-if="!e.disabled" href="javascript:void(0);" @click.stop="imageRemove" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>
                </div>
                <div class="text-center p-3" v-if="C.Str(getValue(), 'null') == 'null' && !e.disabled">
                    <i class="fa fa-upload" style="font-size:2rem"></i>
                    <div>Dosyaları buraya bırakın veya yüklemek için tıklayın.</div>
                </div>
            </div>
            <input type="file" class="form-control" v-bind="$attrs" :id="e.controlId" :accept="C.Str(accept, 'image/png,image/jpeg,image/webp')" @change="setValue($event)" style="display:none;" />            
        </template>
        <template v-else-if="type == 'multi-image'">
            <div :disabled="e.disabled" class="form-control-upload mb-3" @click="multiImageClick" @dragover="multiImageDragOver" @dragleave="multiImageDragLeave" @drop="multiImageDrop">
                <div class="list d-flex flex-wrap gap-2" v-if="getValue()">
                    <div class="item" v-for="r in getValue()" :key="r">
                        <img :src="Web.Server(r, defaultImage, true)" :style="{'min-height': minHeight, 'max-height': maxHeight}" />
                        <a v-if="!e.disabled" href="javascript:void(0);" @click.stop="multiImageRemove(r)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>
                    </div>
                </div>
                <div class="text-center p-3" v-if="C.Str(getValue(), 'null') == 'null' && !e.disabled">
                    <i class="fa fa-upload" style="font-size:2rem"></i>
                    <div>Dosyaları buraya bırakın veya yüklemek için tıklayın.</div>
                </div>
            </div>
            <input type="file" class="form-control" v-bind="$attrs" :id="e.controlId" :accept="C.Str(accept, 'image/png,image/jpeg,image/webp')" @change="setValue($event)" multiple="multiple" style="display:none;" />
        </template>
        <template v-else-if="type == 'multi-upload'">
            <div :disabled="e.disabled" class="form-control-upload mb-3" @click="multiUploadClick" @dragover="multiUploadDragOver" @dragleave="multiUploadDragLeave" @drop="multiUploadDrop">
                <div class="list d-flex flex-wrap gap-2" v-if="getValue()">
                    <div class="item" v-for="r in getValue()" :key="r">
                        <img :src="Web.PreviewMimeType(r)" :style="{'min-height': minHeight, 'max-height': maxHeight}" />
                        <a v-if="!e.disabled" href="javascript:void(0);" @click.stop="multiUploadRemove(r)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>
                    </div>
                </div>
                <div class="text-center p-3" v-if="C.Str(getValue(), 'null') == 'null' && !e.disabled">
                    <i class="fa fa-upload" style="font-size:2rem"></i>
                    <div>Dosyaları buraya bırakın veya yüklemek için tıklayın.</div>
                </div>
            </div>
            <input type="file" class="form-control" v-bind="$attrs" :id="e.controlId" @change="setValue($event)" multiple="multiple" style="display:none;" />
        </template>
        <template v-else-if="type == 'textarea'">
            <div class="form-control textarea">
                <textarea rows="3" class="form-control p-0 border-0" v-bind="$attrs" :id="e.controlId" :value="getValue()" @input="setValue($event)" :disabled="e.disabled"></textarea>
                <span style="position: absolute;right: 0;bottom: -1rem;font-size: 0.8rem;">{{ Text.WordCount(getValue()) }} Kelime, {{ getValue().length }} Karakter</span>
            </div>            
        </template>
        <template v-else-if="type == 'label'">
            <div class="form-control label">{{ getValue() }}</div>
        </template>
        <template v-else-if="type == 'custom'">
            <div class="form-control">
                <slot v-bind="$attrs" :id="e.controlId" :disabled="e.disabled"></slot>
            </div>
        </template>
        <template v-else-if="type == 'text-icon'">
            <input type="text" class="form-control" v-bind="$attrs" :id="e.controlId" :list="e.controlId + '_list'" :value="getValue()" @input="setValue($event)"  style="padding-left:2rem;" :disabled="e.disabled"/>
            <span class="input-btn left"><i :class="icon" /></span>
            <datalist :id="e.controlId + '_list'" v-if="e.list.length > 0">
                <option :value="r" v-for="r in e.list" :key="r" />
            </datalist>
        </template>
        <template v-else>
            <input type="text" class="form-control" v-bind="$attrs" :id="e.controlId" :list="e.controlId + '_list'" :value="getValue()" @input="setValue($event)" :disabled="e.disabled"/>
            <datalist :id="e.controlId + '_list'" v-if="e.list.length > 0">
                <option :value="r" v-for="r in e.list" :key="r" />
            </datalist>
        </template>
        <label :for="e.controlId" v-if="e.title != ''">{{ e.title }}</label>
        </div>
    </div>
</template>
<script>
    import { Enums } from '@/helpers/enums';
    import { appData, C, D, J } from '@/helpers/global';
    import { Web } from '@/helpers/web';
    import { Msg } from '@/helpers/web';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';

    let _uid = 1;
    export default {
        name: "FormControl",
        inheritAttrs: false,
        components: {
        },
        props: {
            modelValue: {
            },
            title: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            list: {
                type: Array,
                default: [],
            },
            size: {
                type: String,
                default: 'col-lg-12'
            },
            bindData: {
                type: String,
                default: 'id'
            },
            bindText: {
                type: String,
                default: 'name'
            },
            inline: {
                type: Boolean,
                default: false
            },
            accept: {
            },
            minHeight: {
                default: '100px'
            },
            maxHeight: {
                default: '100px'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            opaque: {
                type: Boolean,
                default: false
            },
            icon: {
            },
            defaultImage: {
                default: appData.default.img,
            },
            fileSize: {
                type: Number,
                default: 5
            },
            DataList: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                e: {
                    controlId: null,
                    title: this.title,
                    value: this.modelValue,
                    list: this.list,
                    size: this.size,
                    disabled: this.disabled,
                    opaque: this.opaque,
                    editor: this.editor,
                    showPassword: false,
                },
            };
        },
        emits: ['update:modelValue', 'update:fileName', 'update:DataList'],
        watch: {
            title(n) {
                this.e.title = n;
            },
            modelValue(n) {
                this.e.value = n;
            },
            list(n) {
                this.e.list = n;
            },
            size(n) {
                this.e.size = n;
            },
            disabled(n) {
                this.e.disabled = n;
            },
            opaque(n) {
                this.e.opaque = n;
            },
            editor(n) {
                this.e.editor = n;
            },
        },
        methods: {
            getValue() {
                switch (this.type) {
                    case 'editor':
                        return C.Str(this.e.value);
                    case 'file':
                        return C.Str(this.e.value);
                    case 'date':
                        return C.Date(this.e.value);
                    case 'time':
                        return C.Date(this.e.value);
                    case 'datetime':
                        return C.Date(this.e.value);
                    case 'money':
                        return C.Money(this.e.value, 2);
                    case 'decimal':
                        return C.Money(this.e.value, 4);
                    case 'multi-image':
                        return this.e.value;
                    case 'multi-upload':
                        return this.e.value;
                    default:
                        return C.Str(this.e.value);
                }
            },
            setValue(event) {
                const _this = this;
                switch (this.type) {
                    case 'editor':
                        this.$emit('update:modelValue', event);
                        break;
                    case 'file':
                    case 'image':
                        Web.GetFileBase64(event.target, 0, function (status, base64, args) {
                            if (status) {
                                console.log(args.name);
                                _this.$emit('update:fileName', args.name);
                                _this.$emit('update:modelValue', base64);
                            }
                            else { _this.$emit('update:modelValue', null); }
                        });
                        break;
                    case 'multi-image':
                        Web.GetFilesBase64(event.target, function (file) {
                            return file.type.match(/image.*/);
                        }, function (status, result, args) {
                            if (status) {
                                _this.e.value.push(result);
                                _this.$emit('update:modelValue', _this.e.value);

                                _this.DataList.push({ Base64: result, Args: args });
                                _this.$emit('update:DataList', _this.DataList);
                            }
                            else { console.log(result); }
                        });
                        break;
                    case 'multi-upload':
                        Web.GetFilesBase64(event.target, function (file) {
                            let isAllow = false;
                            if (file.size / (1024 * 1024) < _this.fileSize) {
                                for (let i = 0; i < Enums.FILE_TYPE.length; i++) {
                                    for (let j = 0; j < Enums.FILE_TYPE[i].MimeType.length; j++) {
                                        if (Enums.FILE_TYPE[i].MimeType[j] == file.type) {
                                            isAllow = true;
                                            break;
                                        }
                                    }
                                    if (isAllow) { break; }
                                }
                            }
                            else {
                                Msg.Warning('Dosya boyutu ' + _this.fileSize + ' MB\'tan büyük olamaz!');
                            }
                            return isAllow;
                        }, function (status, result, args) {
                            if (status) {
                                _this.e.value.push(result);
                                _this.$emit('update:modelValue', _this.e.value);

                                _this.DataList.push({ Base64: result, Args: args });
                                _this.$emit('update:DataList', _this.DataList);
                            }
                            else { console.log(result); }
                        });
                        break;
                    case 'checkbox':
                        {
                            let l = document.getElementsByName(event.target.name);
                            let p = [];
                            for (let i = 0; i < l.length; i++) {
                                if (l[i].checked) {
                                    p.push(l[i].value);
                                }
                            }
                            this.e.value = p.toString();
                            this.$emit('update:modelValue', this.e.value);
                        }
                        break;
                    case 'switch':
                        {
                            let l = document.getElementsByName(event.target.name);
                            let p = [];
                            for (let i = 0; i < l.length; i++) {
                                if (l[i].checked) {
                                    p.push(l[i].value);
                                }
                            }
                            this.e.value = p.toString();
                            this.$emit('update:modelValue', this.e.value);
                        }
                        break;
                    case 'auto-select':
                        this.e.value = event;
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    case 'money':
                        this.e.value = event.target.value;
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    case 'decimal':
                        this.e.value = C.Dec(event.target.value);
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    case 'date':
                        this.e.value = event;
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    case 'time':
                        this.e.value = event;
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    case 'datetime':
                        this.e.value = event;
                        this.$emit('update:modelValue', this.e.value);
                        break;
                    default:
                        this.e.value = C.Str(event.target.value);
                        this.$emit('update:modelValue', this.e.value);
                        break;
                }
            },
            imageClick() {
                if (this.e.disabled) { return; }
                document.querySelector('#' + this.e.controlId).click();
            },
            imageRemove(event) {
                const c = document.querySelector('#' + this.e.controlId);
                if (c) {
                    c.value = "";
                }                
                this.e.value = 'null';
                this.$emit('update:modelValue', this.e.value);
            },
            imageDragOver(event) {
                if (this.e.disabled) { return; }
                event.preventDefault();
                if (!event.currentTarget.classList.contains('drag')) {
                    event.currentTarget.classList.add('drag');
                }
            },
            imageDragLeave(event) {
                if (this.e.disabled) { return; }
                event.currentTarget.classList.remove('drag');
            },
            imageDrop(event) {
                const _this = this;
                if (this.e.disabled) { return; }
                event.preventDefault();
                event.currentTarget.classList.remove('drag');

                if (event.dataTransfer.files.length > 0) {
                    let file = event.dataTransfer.files[0];
                    if (!file.type.match(/image.*/)) { return; }

                    let reader = new FileReader();
                    reader.onload = function () {
                        _this.e.value = reader.result;
                        _this.$emit('update:modelValue', _this.e.value);
                    };
                    reader.readAsDataURL(file);
                }
                else {
                    let src = event.dataTransfer.getData('url');
                    let o = new Image();
                    o.onload = function () {
                        let c = document.createElement("canvas");
                        c.width = o.width;
                        c.height = o.height;
                        let ctx = c.getContext("2d");
                        ctx.drawImage(o, 0, 0);

                        _this.e.value = c.toDataURL();
                        _this.$emit('update:modelValue', _this.e.value);
                    }
                    o.src = src;
                }
            },

            multiImageClick() {
                if (this.e.disabled) { return; }
                document.querySelector('#' + this.e.controlId).click();
            },
            multiImageRemove(r) {
                J.Delete(this.e.value, r);
                J.DeleteBy(this.DataList, r, 'Base64');
                this.$emit('update:modelValue', this.e.value);
                this.$emit('update:DataList', this.DataList);
            },
            multiImageDragOver(event) {
                if (this.e.disabled) { return; }
                event.preventDefault();
                if (!event.currentTarget.classList.contains('drag')) {
                    event.currentTarget.classList.add('drag');
                }
            },
            multiImageDragLeave(event) {
                if (this.e.disabled) { return; }
                event.currentTarget.classList.remove('drag');
            },
            multiImageDrop(event) {
                const _this = this;
                if (this.e.disabled) { return; }
                event.preventDefault();
                event.currentTarget.classList.remove('drag');
                if (event.dataTransfer.files.length > 0) {
                    Web.GetFilesBase64(event.dataTransfer, function (file) {
                        return file.type.match(/image.*/);
                    }, function (status, result, args) {
                        if (status) {
                            _this.e.value.push(result);
                            _this.$emit('update:modelValue', _this.e.value);

                            _this.DataList.push({ Base64: result, Args: args });
                            _this.$emit('update:DataList', _this.DataList);
                        }
                        else { console.log(result); }
                    });
                }
                else {
                    let src = event.dataTransfer.getData('url');
                    //  url son parçası
                    let fileName = url.split('/').pop();
                    let o = new Image();
                    o.onload = function () {
                        let c = document.createElement("canvas");
                        c.width = o.width;
                        c.height = o.height;
                        let ctx = c.getContext("2d");
                        ctx.drawImage(o, 0, 0);

                        _this.e.value.push(c.toDataURL());
                        _this.$emit('update:modelValue', _this.e.value);

                        _this.DataList.push({ Base64: _this.e.value, Args: { name: fileName } });
                        _this.$emit('update:DataList', _this.DataList);
                    }
                    o.src = src;
                }
            },
            multiUploadClick() {
                if (this.e.disabled) { return; }
                document.querySelector('#' + this.e.controlId).click();
            },
            multiUploadRemove(r) {
                J.Delete(this.e.value, r);
                J.DeleteBy(this.DataList, r, 'Base64');

                this.$emit('update:modelValue', this.e.value);
                this.$emit('update:DataList', this.DataList);
            },
            multiUploadDragOver(event) {
                if (this.e.disabled) { return; }
                event.preventDefault();
                if (!event.currentTarget.classList.contains('drag')) {
                    event.currentTarget.classList.add('drag');
                }
            },
            multiUploadDragLeave(event) {
                if (this.e.disabled) { return; }
                event.currentTarget.classList.remove('drag');
            },
            multiUploadDrop(event) {
                const _this = this;
                if (this.e.disabled) { return; }
                event.preventDefault();
                event.currentTarget.classList.remove('drag');
                if (event.dataTransfer.files.length > 0) {
                    Web.GetFilesBase64(event.dataTransfer, function (file) {
                        let isAllow = false;
                        if (file.size / (1024 * 1024) < _this.fileSize) {
                            for (let i = 0; i < Enums.FILE_TYPE.length; i++) {
                                for (let j = 0; j < Enums.FILE_TYPE[i].MimeType.length; j++) {
                                    if (Enums.FILE_TYPE[i].MimeType[j] == file.type) {
                                        isAllow = true;
                                        break;
                                    }
                                }
                                if (isAllow) { break; }
                            }
                        }
                        else {
                            Msg.Warning('Dosya boyutu ' + _this.fileSize + ' MB\'tan büyük olamaz!');
                        }
                        return isAllow;
                    }, function (status, result, args) {
                        if (status) {
                            _this.e.value.push(result);
                            _this.$emit('update:modelValue', _this.e.value);

                            _this.DataList.push({ Base64: result, Args: args });
                            _this.$emit('update:DataList', _this.DataList);
                        }
                        else { console.log(result); }
                    });
                }
                //else {
                //    let src = event.dataTransfer.getData('url');
                //      let fileName = url.split('/').pop();
                //    let o = new Image();
                //    o.onload = function () {
                //        let c = document.createElement("canvas");
                //        c.width = o.width;
                //        c.height = o.height;
                //        let ctx = c.getContext("2d");
                //        ctx.drawImage(o, 0, 0);

                //        _this.e.value.push(c.toDataURL());
                //        _this.$emit('update:modelValue', _this.e.value);

                //      _this.DataList.push({ Base64: _this.e.value, Args: { name: fileName }});
                //      _this.$emit('update:DataList', _this.DataList);
                //    }
                //    o.src = src;
                //}
            },
        },
        mounted() {
            this.e.controlId = 'c_' + _uid;
            _uid++;
            //let control = document.querySelector('#' + this.e.controlId);
        }
    };
</script>